module.exports = __webpack_public_path__ + "img/MES5Indice3_sommaire.9e1fc345.png";